import './styles.scoped.css'
import {Outlet} from 'react-router-dom'
import {ClientSidebar} from '../../components'
import {Typography, IconButton} from '@mui/material'
import {ArrowBack} from '@mui/icons-material'
import {Link} from 'react-router-dom'
import {useMobile} from '../../hooks'

export default () => {
    const {mobile} = useMobile()

    return (
        <>
            {mobile ? (
                <>
                    <div className="header">
                        <Link to="/clients-management">
                            <IconButton>
                                <ArrowBack />
                            </IconButton>
                        </Link>
                        <Typography variant="h6" color="text.primary">
                            Profile Details
                        </Typography>
                    </div>
                    <br />
                </>
            ) : (
                <>
                    <Typography variant="body1" color="text.secondary">
                        <Link className="link" to="/clients-management">
                            Clients Management
                        </Link>{' '}
                        / Profile Details
                    </Typography>
                    <br />
                    <div className="back-container">
                        <Link className="back-button" to="/clients-management">
                            <ArrowBack style={{color: '#ffffff'}} fontSize="small" />
                        </Link>
                        <Typography variant="h5" color="text.primary">
                            Profile Details
                        </Typography>
                    </div>
                </>
            )}
            <br />
            <br />
            <div className="container">
                {!mobile && <ClientSidebar />}
                <div className="page">
                    {mobile && (
                        <>
                            <ClientSidebar />
                            <br />
                        </>
                    )}
                    <Outlet />
                </div>
            </div>
            <br />
            <br />
        </>
    )
}
